import Livia81 from './Livia 8 (1).webp'
import Livia82 from './Livia 8 (2).webp'
import Livia83 from './Livia 8 (3).webp'
import Livia84 from './Livia 8 (4).webp'
import Livia85 from './Livia 8 (5).webp'
import Livia86 from './Livia 8 (6).webp'
import Livia87 from './Livia 8 (7).webp'
import Livia88 from './Livia 8 (8).webp'
import Livia89 from './Livia 8 (9).webp'
import Livia810 from './Livia 8 (10).webp'


const Livia8images =[
    Livia81,Livia82,Livia83,Livia84,Livia85,Livia86,Livia87,Livia88,Livia89,Livia810
]

export default Livia8images;